import { createContext, useContext } from "react";

type LoadingContextType = {
  isLoading: boolean;
  increaseLoading: () => void;
  decreaseLoading: () => void;
};

export const LoadingContext = createContext<LoadingContextType>({
  isLoading: false,
  increaseLoading: () => {},
  decreaseLoading: () => {},
});

export const useLoading = () => useContext(LoadingContext);